import { useEffect, useState } from "react";
import { fetchTrainingSessions } from "../api/graph";
import { useGraphToken } from "../auth/useGraphToken";
import type { TrainingSession } from "../types/navigator";

export interface TrainingState {
  sessions: TrainingSession[];
  loading: boolean;
  error: string | null;
  reload: () => void;
}

export function useTrainingData(): TrainingState {
  const getToken = useGraphToken();
  const [sessions, setSessions] = useState<TrainingSession[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [reloadKey, setReloadKey] = useState(0);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        setLoading(true);
        setError(null);
        const token = await getToken();
        const rows = await fetchTrainingSessions(token);
        if (cancelled) return;
        setSessions(rows);
      } catch (e) {
        if (cancelled) return;
        setError(e instanceof Error ? e.message : String(e));
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [getToken, reloadKey]);

  return {
    sessions,
    loading,
    error,
    reload: () => setReloadKey((k) => k + 1),
  };
}
